
import { useState, useEffect } from "react";
import { useProfile } from "@/hooks/useProfile";
import { useWorkoutPlans } from "@/hooks/useWorkoutPlans";
import { useRoutines } from "@/hooks/useRoutines";
import { WorkoutPlansSection } from "@/components/routines/sections/components/WorkoutPlansSection";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Search, Library } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IntroTour } from "@/components/intro/IntroTour";
import { TutorialButton } from "@/components/intro/TutorialButton";
import { supabase } from "@/integrations/supabase/client";

const Rutina = () => {
  const [openSection, setOpenSection] = useState("routines");
  const [showTutorial, setShowTutorial] = useState(false);
  const [searchParams] = useSearchParams();
  const {
    profile
  } = useProfile();
  const {
    data: workoutPlans,
    isLoading: isLoadingPlans,
    refetch: refetchWorkoutPlans
  } = useWorkoutPlans();
  const {
    data: routines,
    isLoading: isLoadingRoutines
  } = useRoutines();
  const navigate = useNavigate();
  const isLoading = isLoadingPlans || isLoadingRoutines;

  // Auto-activate tutorial if coming from dashboard
  useEffect(() => {
    const shouldStartTutorial = searchParams.get("tutorial") === "true";
    if (shouldStartTutorial && profile) {
      // Solo activar el tutorial si el usuario NO lo ha visto
      supabase
        .from('user_settings')
        .select('has_seen_tutorial')
        .eq('user_id', profile.id)
        .single()
        .then(({ data }) => {
          if (!data?.has_seen_tutorial) {
            setShowTutorial(true);
          }
          // Limpiar URL siempre
          navigate("/rutina", { replace: true });
        });
    }
  }, [searchParams, navigate, profile]);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-primary/10 via-background to-background text-primary">
      <IntroTour run={showTutorial} setRun={setShowTutorial} />
      <TutorialButton onClick={() => setShowTutorial(true)} />
      
      <main className="container pt-16 mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6 workout-header">
          <div className="flex items-center gap-2">
            <Button variant="ghost" onClick={() => navigate("/")} className="dark:bg-[#2196A3] dark:text-white ocean:bg-[#2196A3] ocean:hover:bg-background ocean:hover:text-[#2196A3]  text-primary hover:text-primary/80 hover:bg-background/20">
              <ArrowLeft className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
              Volver
            </Button>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-primary">
              Mis Rutinas
            </h1>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 flex-1 sm:flex-none sm:ml-auto">
            <Button variant="outline" className="w-full sm:w-auto border-border hover:bg-background/10 hover:text-primary/50 text-sm sm:text-base search-routines text-primary" onClick={() => navigate("/rutina/buscar")}>
              <Search className="mr-2 h-4 w-4" />
              Buscar Planes
            </Button>
            {(profile?.role === "profesor" || profile?.role === "manager" || profile?.role === "admin") && (
              <Button
                variant="outline"
                className="w-full sm:w-auto border-border hover:bg-background/10 hover:text-primary/50 text-sm sm:text-base text-primary"
                onClick={() => navigate("/rutina/portafolio")}
              >
                <Library className="mr-2 h-4 w-4" />
                Portafolio de rutinas
              </Button>
            )}
          </div>
        </div>

        <WorkoutPlansSection 
          workoutPlans={workoutPlans || []} 
          profile={profile} 
          openSection={openSection} 
          setOpenSection={setOpenSection} 
          refetchWorkoutPlans={refetchWorkoutPlans} 
          routines={routines || []} 
          isLoading={isLoading} 
        />
      </main>
    </div>
  );
};

export default Rutina;
